// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3Pg71","btnRed":"styles_btnRed__XB-ux","loading":"styles_loading__AAQoQ"};